import React from 'react';
import codingImg from '../../image/coder.svg';
import { FaHtml5, FaCss3Alt, FaBootstrap, FaReact, FaNodeJs,FaGithub   } from 'react-icons/fa';
import {DiJavascript, DiMongodb, DiFirebase, DiHeroku } from 'react-icons/di';
import './Skill.css'
const Skill = () => {
    return (
        <div className='container mt-5 pt-5 pb-0 pb-md-5'>
            <div className='row d-flex justify-content-between'>
                <div className='col-md-6' data-aos="zoom-in">
                    <img src={codingImg} alt="" className='img-fluid' />
                </div>
                <div className='col-md-6 ' data-aos="flip-left">
                    <h2 className='fw-bold text-center font-monospace'>What I Can</h2>
                    <p className='lead text-center'>Passionate Front End Developer WHO WANTS TO EXPLORE EVERY TECH STACK</p>

                    <ul className='skillList'>
                        <li className='skillListItem'> <FaHtml5/> <p className='listTitle'> HTML</p>  </li>
                        <li className='skillListItem'> <FaCss3Alt/> <p className='listTitle'> CSS</p>  </li>
                        <li className='skillListItem'> <FaBootstrap/> <p className='listTitle'> Bootstrap</p>  </li>
                        <li className='skillListItem'> <DiJavascript/> <p className='listTitle'> JavaScript</p>  </li>
                        <li className='skillListItem'> <FaReact/> <p className='listTitle'> React Js</p>  </li>
                        <li className='skillListItem'> <FaNodeJs/> <p className='listTitle'> Node Js</p>  </li>
                        <li className='skillListItem'> <DiMongodb/> <p className='listTitle'> MongoDB</p>  </li>
                        <li className='skillListItem'> <DiFirebase/> <p className='listTitle'> Firebase</p>  </li>
                        <li className='skillListItem'> <DiHeroku/> <p className='listTitle'> Heroku </p>  </li>
                        <li className='skillListItem'> <FaGithub/> <p className='listTitle'> GitHub</p>  </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Skill;